<div id="language-selector">
  <button class="lang-toggle-btn" type="button" (click)="openLangOpt()">
    <span class="selected-lang">{{ selectedLang }}</span>
    <img
      [src]="listOpen ? 'assets/images/chevron-up.svg' : 'assets/images/chevron-down.svg'"
      alt="Toggle Language List" />
  </button>
  <div *ngIf="listOpen" class="lang-list">
    <ul>
      <li *ngFor="let lang of langList" (click)="setLang(lang.value)" class="lang-option">
        <span class="lang-text">{{ lang.value }}</span>
      </li>
    </ul>
  </div>
</div>
